<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <!-- Email Template Management Card -->
    <div class="bg-white rounded-lg shadow-md overflow-hidden">
      <div class="bg-primary/10 p-4 border-b border-primary/20">
        <h2 class="text-xl font-semibold text-primary">Email Template Management</h2>
        <p class="text-sm text-gray-600 mt-1">Create and manage email templates for automated communications</p>
      </div>
      
      <div class="p-6 flex flex-col items-center justify-center py-8">
        <router-link
          to="/administration/email-templates"
          class="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary inline-block"
        >
          Manage Email Templates
        </router-link>
      </div>
    </div>

    <!-- User Role Management Card -->
    <div class="bg-white rounded-lg shadow-md overflow-hidden">
      <div class="bg-blue-50 p-4 border-b border-blue-100">
        <h2 class="text-xl font-semibold text-blue-700">User Role Management</h2>
        <p class="text-sm text-gray-600 mt-1">Assign and manage user roles and permissions</p>
      </div>
      
      <div class="p-6 flex flex-col items-center justify-center py-8">
        <p class="text-gray-500 mb-4 text-center">This feature will be implemented in a future update.</p>
        <router-link
          to="/administration/user-roles"
          class="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 inline-block"
        >
          Manage User Roles
        </router-link>
      </div>
    </div>
    
    <!-- Due Date Management Card -->
    <div class="bg-white rounded-lg shadow-md overflow-hidden">
      <div class="bg-amber-50 p-4 border-b border-amber-100">
        <h2 class="text-xl font-semibold text-amber-700">Due Date Management</h2>
        <p class="text-sm text-gray-600 mt-1">Configure due dates for different actions and document types</p>
      </div>
      
      <div class="p-6 flex flex-col items-center justify-center py-8">
        <router-link
          to="/administration/due-dates"
          class="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-amber-600 hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 inline-block"
        >
          Manage Due Dates
        </router-link>
      </div>
    </div>
    
    <!-- System Configuration Card -->
    <div class="bg-white rounded-lg shadow-md overflow-hidden">
      <div class="bg-green-50 p-4 border-b border-green-100">
        <h2 class="text-xl font-semibold text-green-700">System Configuration</h2>
        <p class="text-sm text-gray-600 mt-1">Configure system-wide settings and parameters</p>
      </div>
      
      <div class="p-6 flex flex-col items-center justify-center py-8">
        <p class="text-gray-500 mb-4 text-center">This feature will be implemented in a future update.</p>
        <router-link
          to="/administration/system-config"
          class="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-100 bg-green-700 hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 inline-block"
        >
          Configure System
        </router-link>
      </div>
    </div>
    
    <!-- Audit Logs Card -->
    <div class="bg-white rounded-lg shadow-md overflow-hidden">
      <div class="bg-purple-50 p-4 border-b border-purple-100">
        <h2 class="text-xl font-semibold text-purple-700">Audit Logs</h2>
        <p class="text-sm text-gray-600 mt-1">View system activity and user action logs</p>
      </div>
      
      <div class="p-6 flex flex-col items-center justify-center py-8">
        <p class="text-gray-500 mb-4 text-center">This feature will be implemented in a future update.</p>
        <router-link
          to="/administration/audit-logs"
          class="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 inline-block"
        >
          View Audit Logs
        </router-link>
      </div>
    </div>
    
    <!-- Knowledgebase Advisori Card -->
    <div class="bg-white rounded-lg shadow-md overflow-hidden">
      <div class="bg-indigo-50 p-4 border-b border-indigo-100">
        <h2 class="text-xl font-semibold text-indigo-700">Knowledgebase Advisori</h2>
        <p class="text-sm text-gray-600 mt-1">Manage the knowledge database for Advisori</p>
      </div>
      
      <div class="p-6 flex flex-col items-center justify-center py-8">
        <router-link
          to="/administration/manage-knowledgebase"
          class="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 inline-block"
        >
          Manage Knowledgebase
        </router-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AdminDashboard',
  emits: ['navigate']
});
</script>
